"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenHelperFactory = exports.memoizeWithTokenHelper = exports.createTokenHelperMiddleware = void 0;
const axios_1 = __importStar(require("axios"));
const http_errors_1 = __importDefault(require("http-errors"));
const jwt_decode_1 = require("jwt-decode");
const R = __importStar(require("ramda"));
const rax = __importStar(require("retry-axios"));
const types_1 = require("./types");
const utils = __importStar(require("./utils"));
const LOCAL_KEYCLOAK_REGION_MAP = {
    8080: 'eu',
    8082: 'us',
    8084: 'ap'
};
/**
 * Gets the JWT ID
 */
const getJti = R.prop('jti');
/**
 * Cache the token using the jti as the hash key
 */
const memoizeWithToken = (func) => utils.memoizeWith(getJti, func);
/**
 ****************************************************** USER DATA ******************************************************
 */
/**
 * Gets the token azp
 */
const getAzp = R.prop('azp');
/**
 * Gets the token issuer
 */
const getIssuer = R.prop('iss');
/**
 * Gets the user's login source
 */
const getLoginSource = R.prop('login_source');
/**
 * Gets the scope
 */
const getScopes = R.pipe(R.propOr('', 'scope'), R.split(' '));
/**
 * Gets the session state
 */
const getSessionState = R.prop('session_state');
/**
 * Gets user's id
 */
const getUserId = R.prop('sub');
/**
 * Gets user's preferred name
 */
const getUsername = R.prop('preferred_username');
/**
 * Gets the user's family name
 */
const getFamilyName = R.prop('family_name');
/**
 * Gets user's given name
 */
const getGivenName = R.prop('given_name');
/**
 * Gets user's name
 */
const getName = R.prop('name');
/**
 * Gets the user's email
 */
const getEmail = R.prop('email');
/**
 * Gets the token audience
 */
const getAudience = R.prop('aud');
/**
 * Gets the token expiration time
 */
const getExpiration = R.propOr(undefined, 'exp');
/**
 * Gets the user's groups data
 */
const getGroups = R.propOr([], 'groups');
/**
 * Gets the user's group data
 */
const getGroup = memoizeWithToken(R.pipe(getGroups, R.head));
/**
 * Gets the user's group id
 */
const getGroupId = memoizeWithToken(R.pipe(getGroup, R.prop('group_id')));
/**
 * Gets the user's partner ids
 */
const getPids = R.propOr([], 'pids');
/**
 * Gets the user's realm
 */
const getRealm = memoizeWithToken((token) => {
    return getIssuer(token).split('/realms/')[1];
});
/**
 * Gets the issuer's region
 */
const getRegionFromIssuer = (token) => {
    const issuer = getIssuer(token);
    const matchesLocal = issuer.match(/http:\/\/localhost:(\d{4})\//);
    const matchesStaging = issuer.match(/https:\/\/keycloak\.staging\.([a-z]{2})\d\./);
    const matchesPlaygroundOrProduction = issuer.match(/https:\/\/auth\.(?:playground\.)?([a-z]{2})\./);
    if (matchesLocal) {
        return LOCAL_KEYCLOAK_REGION_MAP[matchesLocal[1]];
    }
    else if (matchesStaging) {
        return matchesStaging[1];
    }
    else if (matchesPlaygroundOrProduction) {
        const region = matchesPlaygroundOrProduction[1];
        return region === 'oc' ? 'ap' : region;
    }
};
/**
 * Gets the user's region
 */
const getRegion = memoizeWithToken((token) => {
    const getRegionFromRemoteIds = (token) => {
        const userIdsByRegion = getAllUserIds(token);
        const userRegions = Object.keys(userIdsByRegion);
        return userRegions.find((region) => userIdsByRegion[region] === getUserId(token));
    };
    if (isProxyUser(token)) {
        return getRegionFromRemoteIds(token) || getRegionFromIssuer(token);
    }
    else {
        return getRegionFromIssuer(token);
    }
});
/**
 * Determines if a token has all scopes passed
 */
const hasScopes = (token, scopes) => {
    const tokenScopes = getScopes(token);
    return scopes.every((scope) => tokenScopes.includes(scope));
};
/**
 * Checks if the user is in the `klarna` realm
 */
const isInKlarnaRealm = memoizeWithToken(R.pipe(getRealm, R.both(utils.isNotNilAndNotEmpty, R.equals('klarna'))));
/**
 * Checks if the user is in the `merchants` realm
 */
const isInMerchantsRealm = R.pipe(getRealm, R.both(utils.isNotNilAndNotEmpty, R.equals('merchants')));
/**
 * Checks if the token is expired or not
 */
const isExpired = (token) => {
    const expiration = getExpiration(token);
    return R.or(R.isNil(expiration), R.lt(expiration, (new Date().getTime() / 1000)));
};
/**
 * Returns all the existing user ids from the different regions
 */
const getAllUserIds = (token) => {
    const regionIds = {
        eu: R.propOr(undefined, 'eu_user_id')(token),
        us: R.propOr(undefined, 'us_user_id')(token),
        ap: R.propOr(undefined, 'ap_user_id')(token)
    };
    return R.filter(utils.isNotNilAndNotEmpty, regionIds);
};
/**
 * Checks if the user is a proxy user
 */
const isProxyUser = R.propIs(String, 'proxy_user_id');
/**
 * Gets a proxy user's id
 */
const getProxyUserId = R.propOr(undefined, 'proxy_user_id');
/**
 ***************************************************** PERMISSIONS *****************************************************
 */
const flattenEntityPermissions = (entitiesPermissions) => {
    return Object.values(entitiesPermissions)
        .reduce((currentAllPermissions, permissions) => {
        if (permissions) {
            for (const [clientId, roles] of Object.entries(permissions)) {
                if (clientId in currentAllPermissions) {
                    currentAllPermissions[clientId] = utils.concatAndUniq(currentAllPermissions[clientId], roles);
                }
                else {
                    currentAllPermissions[clientId] = roles;
                }
            }
        }
        return currentAllPermissions;
    }, {});
};
const getEntityPermissionsClaimName = (entityType) => {
    if (types_1.allowedEntityTypes.includes(entityType)) {
        return `${entityType}_permissions`;
    }
    else {
        throw new Error(`Unknown entity type ${entityType}`);
    }
};
const getPendingEntityPermissionsClaimName = (entityType) => {
    if (types_1.allowedEntityTypes.includes(entityType)) {
        return `${entityType}_permissions_pending`;
    }
    else {
        throw new Error(`Unknown entity type ${entityType}`);
    }
};
/**
 * Gets all the client-role mappings assigned to the user
 */
const getResourceAccess = R.propOr({}, 'resource_access');
/**
 * Removed the nested `roles` key from the resource access
 */
const getUserPermissions = memoizeWithToken(R.pipe(getResourceAccess, R.mapObjIndexed(access => R.propOr([], 'roles', access))));
/**
 * Get permissions for an entity
 */
const getPermissionsForEntityType = (token, entityType) => {
    const entityPermissionsClaim = getEntityPermissionsClaimName(entityType);
    return R.propOr({}, entityPermissionsClaim)(token);
};
/**
 * Get permissions for a pending entity
 */
const getPermissionsForPendingEntityType = (token, entityType) => {
    const entityPermissionsClaim = getPendingEntityPermissionsClaimName(entityType);
    return R.propOr({}, entityPermissionsClaim)(token);
};
const getAllPermissions = memoizeWithToken((token) => {
    const userPermissions = getUserPermissions(token);
    const merchantPermissions = getPermissionsForEntityType(token, 'merchant');
    const allMerchantPermissions = flattenEntityPermissions(merchantPermissions);
    const estorePermissions = getPermissionsForEntityType(token, 'estore');
    const allEstorePermissions = flattenEntityPermissions(estorePermissions);
    const klarnaResourcePermissions = getPermissionsForEntityType(token, 'klarna_resource');
    const allKlarnaResourcePermissions = flattenEntityPermissions(klarnaResourcePermissions);
    const platformPermissions = getPermissionsForEntityType(token, 'platform');
    const allPlatformPermissions = flattenEntityPermissions(platformPermissions);
    const allPermissions = {};
    for (const permissions of [userPermissions, allMerchantPermissions, allEstorePermissions, allKlarnaResourcePermissions, allPlatformPermissions]) {
        for (const [clientId, roles] of Object.entries(permissions)) {
            if (clientId in allPermissions) {
                allPermissions[clientId] = utils.concatAndUniq(allPermissions[clientId], roles);
            }
            else {
                allPermissions[clientId] = roles;
            }
        }
    }
    return allPermissions;
});
/**
 * Gets all the permissions for an entity (eid/mid)
 */
const getAllPermissionsForEntity = (token, entityType, entityId) => {
    const permissions = getPermissionsForEntityType(token, entityType);
    return R.propOr({}, entityId)(permissions);
};
/**
 * Gets the permissions for a client
 */
const getPermissions = (token, clientId) => {
    const allPermissions = getAllPermissions(token);
    return R.propOr([], clientId)(allPermissions);
};
/**
 * Checks if the user has access to a client with a given permission
 */
const hasPermission = (token, clientId, permission) => {
    const permissions = getPermissions(token, clientId);
    return permissions.includes(permission);
};
/**
 * Checks if the user has the given user permission for a client
 */
const hasUserPermission = (token, clientId, permission) => {
    const userPermissions = getUserPermissions(token);
    const permissions = R.propOr([], clientId, userPermissions);
    return permissions.includes(permission);
};
const getPermissionsForEntity = (token, entityType, entityId, clientId) => {
    const permissions = getAllPermissionsForEntity(token, entityType, entityId);
    return R.propOr([], clientId)(permissions);
};
const hasPermissionForEntity = (token, entityType, entityId, clientId, permission) => {
    const permissions = getPermissionsForEntity(token, entityType, entityId, clientId);
    return permissions.includes(permission);
};
/**
 * Gets the merged permissions of all the entities of a given type
 */
const getPermissionsForAllEntities = (token, entityType) => {
    const entityPermissions = getPermissionsForEntityType(token, entityType);
    return flattenEntityPermissions(entityPermissions);
};
/**
 * Checks for a client/role in the merged permissions of all the entities of a given type
 */
const hasPermissionForAnyEntity = (token, entityType, clientId, permission) => {
    const allPermissions = getPermissionsForAllEntities(token, entityType);
    return R.pipe(R.propOr([], clientId), R.includes(permission))(allPermissions);
};
/**
 * Checks if the user has access to a client with a given permission of pattern `*-full`
 */
const hasFullPermission = (token, clientId) => {
    const permissions = getPermissions(token, clientId);
    return !!permissions.find(role => /^\w+-full$/.test(role));
};
/**
 * Checks if the user has access to a client for a mid with a given permission of pattern `*-full`
 */
const hasFullPermissionForEntity = (token, entityType, entityId, clientId) => {
    const permissions = getPermissionsForEntity(token, entityType, entityId, clientId);
    return !!permissions.find(permission => /^\w+-full$/.test(permission));
};
/**
 * Gets the default permissions that are applied to all entities unless overridden
 */
const getDefaultPermissions = R.propOr({}, 'default_permissions');
/**
 * Checks if the user has been assigned default permissions
 */
const hasDefaultPermissions = memoizeWithToken(R.pipe(getDefaultPermissions, utils.isNotNilAndNotEmpty));
/**
 ******************************************************** ROLES ********************************************************
 */
const flattenEntityRoles = (entityRoles) => {
    const values = R.values(entityRoles);
    const notNil = R.filter(utils.isNotNil, values);
    const flatten = R.flatten(notNil);
    return R.uniq(flatten);
};
const getEntityRolesClaimName = (entityType) => {
    if (types_1.allowedEntityTypes.includes(entityType)) {
        return `${entityType}_roles`;
    }
    else {
        throw new Error(`Unknown entity type ${entityType}`);
    }
};
const getRealmAccess = R.propOr({}, 'realm_access');
const getUserRoles = memoizeWithToken(R.pipe(getRealmAccess, R.propOr([], 'roles')));
/**
 * Get realm-role mapping for an entityType
 */
const getRolesForEntityType = (token, entityType) => {
    const entityRolesClaim = getEntityRolesClaimName(entityType);
    return R.propOr({}, entityRolesClaim)(token);
};
/**
 * Gets the merged roles of all the entities of a given type
 */
const getRolesForAllEntities = (token, entityType) => {
    const entityRoles = getRolesForEntityType(token, entityType);
    return flattenEntityRoles(entityRoles);
};
/**
 * Gets all the roles
 */
const getRoles = memoizeWithToken((token) => {
    const userRoles = getUserRoles(token);
    const allMerchantRoles = getRolesForAllEntities(token, 'merchant');
    const allEstoreRoles = getRolesForAllEntities(token, 'estore');
    const allKlarnaResourceRoles = getRolesForAllEntities(token, 'klarna_resource');
    const allPlatformRoles = getRolesForAllEntities(token, 'platform');
    return R.uniq([
        ...userRoles,
        ...allMerchantRoles,
        ...allEstoreRoles,
        ...allKlarnaResourceRoles,
        ...allPlatformRoles
    ]);
});
/**
 * Checks if the user has been assigned a given role
 */
const hasRole = (token, role) => {
    const allRoles = getRoles(token);
    return allRoles.includes(role);
};
/**
 * Gets the user's roles for an entity
 */
const getRolesForEntity = (token, entityType, entityId) => {
    const roles = getRolesForEntityType(token, entityType);
    return R.propOr([], entityId)(roles);
};
/**
 * Checks if the user has been assigned a given role for an entity
 */
const hasRoleForEntity = (token, entityType, entityId, role) => {
    const roles = getRolesForEntity(token, entityType, entityId);
    return roles.includes(role);
};
/**
 * Checks for a role in the merged roles of all the entities of a given type
 */
const hasRoleForAnyEntity = (token, entityType, role) => {
    const allRoles = getRolesForAllEntities(token, entityType);
    return allRoles.includes(role);
};
/**
 ******************************************************* CLIENTS *******************************************************
 */
/**
 * Get the clients the user has access to
 */
const getClients = memoizeWithToken((token) => {
    const userPermissions = getAllPermissions(token);
    return Object.keys(userPermissions);
});
/**
 * Does the user have access to a client
 */
const hasClient = (token, clientId) => {
    const clientIds = getClients(token);
    return clientIds.includes(clientId);
};
/**
 * Get the clients the user has access to for a specific entity
 */
const getClientsForEntity = (token, entityType, entityId) => {
    const permissions = getAllPermissionsForEntity(token, entityType, entityId);
    return Object.keys(permissions);
};
/**
 * Get the clients the user has access to for a specific entity type
 */
const getClientsForEntityType = (token, entityType) => {
    const permissions = getPermissionsForEntityType(token, entityType);
    const flattenedPermissions = flattenEntityPermissions(permissions);
    return Object.keys(flattenedPermissions);
};
/**
 * Get the clients the user has access to for all entities
 */
const getClientsForAllEntities = memoizeWithToken((token) => {
    const merchantPermissions = getPermissionsForEntityType(token, 'merchant');
    const flattenedMerchantPermissions = flattenEntityPermissions(merchantPermissions);
    const estorePermissions = getPermissionsForEntityType(token, 'estore');
    const flattenedEstorePermissions = flattenEntityPermissions(estorePermissions);
    const klarnaResourcePermissions = getPermissionsForEntityType(token, 'klarna_resource');
    const flattenedKlarnaResourcePermissions = flattenEntityPermissions(klarnaResourcePermissions);
    const platformPermissions = getPermissionsForEntityType(token, 'platform');
    const flattenedPlatformPermissions = flattenEntityPermissions(platformPermissions);
    return utils.concatAndUniq(Object.keys(flattenedMerchantPermissions), Object.keys(flattenedEstorePermissions), Object.keys(flattenedKlarnaResourcePermissions), Object.keys(flattenedPlatformPermissions));
});
/**
 * Does the user have access to a client for a specific entity
 */
const hasClientForEntity = (token, entityType, entityId, clientId) => {
    const clientIds = getClientsForEntity(token, entityType, entityId);
    return clientIds.includes(clientId);
};
/**
 * Does the user have access to a client for a specific entity type
 */
const hasClientForEntityType = (token, entityType, clientId) => {
    const clientIds = getClientsForEntityType(token, entityType);
    return clientIds.includes(clientId);
};
/**
 * Does the user have access to a client for any entity
 */
const hasClientForAnyEntity = (token, clientId) => {
    const clients = getClientsForAllEntities(token);
    return clients.includes(clientId);
};
/**
 ****************************************************** ENTITIES ******************************************************
 */
/**
 *  Get ids for an entity (merchant or estore)
 */
const getEntityIds = (token, entityType) => {
    const permissions = getPermissionsForEntityType(token, entityType);
    const entityIds = R.keys(permissions);
    return R.sortBy(R.identity, entityIds);
};
/**
 *  Get ids for a pending entity (merchant or estore)
 */
const getPendingEntityIds = (token, entityType) => {
    const permissions = getPermissionsForPendingEntityType(token, entityType);
    const entityIds = R.keys(permissions);
    return R.sortBy(R.identity, entityIds);
};
/**
 * Checks if the user has access to an entity
 */
const hasEntity = (token, entityType, entityId) => {
    const entityIds = getEntityIds(token, entityType);
    return entityIds.includes(entityId);
};
/**
 * Checks if the user has access to a pending entity
 */
const hasPendingEntity = (token, entityType, entityId) => {
    const entityIds = getPendingEntityIds(token, entityType);
    return entityIds.includes(entityId);
};
/**
 * Gets the entityIds for which the user has client access
 */
const getEntityIdsForClient = (token, entityType, clientId) => {
    const entitiesPermissions = getPermissionsForEntityType(token, entityType);
    return R.pipe(R.mapObjIndexed((_, entityId) => hasClientForEntity(token, entityType, entityId, clientId)), R.filter(R.equals(true)), R.keys)(entitiesPermissions);
};
/**
 * Gets the entity IDs for which the user has a specific role for
 */
const getEntityIdsForRole = (token, entityType, role) => {
    const entitiesRoles = getRolesForEntityType(token, entityType);
    return R.pipe(R.mapObjIndexed((_, entityId) => hasRoleForEntity(token, entityType, entityId, role)), R.filter(R.equals(true)), R.keys)(entitiesRoles);
};
/**
 * Gets the entityIds for which the user has a specific permission for
 */
const getEntityIdsForPermission = (token, entityType, clientId, permission) => {
    const entitiesPermissions = getPermissionsForEntityType(token, entityType);
    return R.pipe(R.mapObjIndexed((_, entityId) => hasPermissionForEntity(token, entityType, entityId, clientId, permission)), R.filter(R.equals(true)), R.keys)(entitiesPermissions);
};
/**
 *  Gets the user's eStore data
 */
const getEstores = memoizeWithToken(R.pipe(R.pathOr([], ['user_attributes', 'roles']), (eStoreRoles) => {
    return eStoreRoles.map((estoreRoleString) => estoreRoleString.split(/\s*:\s*/).slice(0, 2));
}, (eStorePairs) => {
    return R.fromPairs(eStorePairs);
}));
/**
 * Checks if the user is a transacting user (has access to at least one MID)
 */
const isTransactingUser = (token) => {
    const mids = getEntityIds(token, 'merchant');
    const pendingMids = getPendingEntityIds(token, 'merchant');
    return !R.isEmpty([...mids, ...pendingMids]);
};
const getDefaultRoles = R.propOr([], 'default_roles');
const getEstorePermissions = R.propOr({}, 'estore_permissions');
const getMerchantPermissions = R.propOr({}, 'merchant_permissions');
const getPendingMerchantPermissions = R.propOr({}, 'merchant_permissions_pending');
const getKlarnaResourcePermissions = R.propOr({}, 'klarna_resource_permissions');
const getPlatformPermissions = R.propOr({}, 'platform_permissions');
const getEstoreRoles = R.propOr({}, 'estore_roles');
const getMerchantRoles = R.propOr({}, 'merchant_roles');
const getPendingMerchantRoles = R.propOr({}, 'merchant_roles_pending');
const getKlarnaResourceRoles = R.propOr({}, 'klarna_resource_roles');
const getPlatformRoles = R.propOr({}, 'platform_roles');
const assignDefaultAccess = (defaultAccess, noValue) => R.mapObjIndexed((access) => {
    if (access === null) {
        return noValue;
    }
    else if (R.isEmpty(access)) {
        return defaultAccess;
    }
    else {
        return access;
    }
});
const resolveDefaults = (token) => {
    const defaultPermissions = getDefaultPermissions(token);
    const defaultRoles = getDefaultRoles(token);
    // permissions
    const assignDefaultPermissions = assignDefaultAccess(defaultPermissions, {});
    const merchantPermissions = assignDefaultPermissions(getMerchantPermissions(token));
    const pendingMerchantPermissions = assignDefaultPermissions(getPendingMerchantPermissions(token));
    const estorePermissions = assignDefaultPermissions(getEstorePermissions(token));
    const klarnaResourcePermissions = assignDefaultPermissions(getKlarnaResourcePermissions(token));
    const platformPermissions = assignDefaultPermissions(getPlatformPermissions(token));
    // roles
    const assignDefaultRoles = assignDefaultAccess(defaultRoles, []);
    const merchantRoles = assignDefaultRoles(getMerchantRoles(token));
    const pendingMerchantRoles = assignDefaultRoles(getPendingMerchantRoles(token));
    const estoreRoles = assignDefaultRoles(getEstoreRoles(token));
    const klarnaResourceRoles = assignDefaultRoles(getKlarnaResourceRoles(token));
    const platformRoles = assignDefaultRoles(getPlatformRoles(token));
    return Object.assign(Object.assign({}, token), { merchant_permissions: merchantPermissions, merchant_permissions_pending: pendingMerchantPermissions, merchant_roles: merchantRoles, merchant_roles_pending: pendingMerchantRoles, estore_permissions: estorePermissions, klarna_resource_permissions: klarnaResourcePermissions, platform_permissions: platformPermissions, estore_roles: estoreRoles, klarna_resource_roles: klarnaResourceRoles, platform_roles: platformRoles });
};
const createVoidLogger = () => () => { };
const defaultLogger = {
    debug: createVoidLogger(),
    error: createVoidLogger(),
    info: createVoidLogger(),
    warn: createVoidLogger()
};
const flagAsDeprecated = (func, { logger = console, replacementMethod } = {}) => (...args) => {
    logger.warn('This method is deprecated', {
        payload: {
            replacement: replacementMethod ? `Please use ${replacementMethod}` : 'NONE'
        }
    });
    return func(...args);
};
const isError = (value) => {
    return value instanceof Error;
};
const isLoggableError = (value) => {
    return isError(value) || typeof value === 'string';
};
const isAxiosError = (value) => {
    return value instanceof axios_1.AxiosError;
};
const validKeycloakHosts = [
    'localhost',
    'keycloak.staging.eu1.meta.klarna.net',
    'keycloak.staging.us1.meta.klarna.net',
    'keycloak.staging.ap1.meta.klarna.net',
    'auth.playground.eu.portal.klarna.com',
    'auth.playground.us.portal.klarna.com',
    'auth.playground.oc.portal.klarna.com',
    'auth.eu.portal.klarna.com',
    'auth.us.portal.klarna.com',
    'auth.oc.portal.klarna.com'
];
const tokenHelperFactory = (jwtToken_1, ...args_1) => __awaiter(void 0, [jwtToken_1, ...args_1], void 0, function* (jwtToken, { correlationId, fetchUserInfo, forbidExternalClients = true, logger = defaultLogger, proxy = false, timeout = 15000 } = {}) {
    let token = (0, jwt_decode_1.jwtDecode)(jwtToken);
    if (forbidExternalClients && !hasScopes(token, ['klarna'])) {
        throw new Error('Validation error - token does contain required internal "klarna" scope');
    }
    const issuerUrl = new URL(token.iss);
    if (!validKeycloakHosts.includes(issuerUrl.hostname)) {
        throw new Error('Validation error - issuer is not a valid host');
    }
    if ((fetchUserInfo !== false) && (fetchUserInfo || token.fetch_user_info)) {
        try {
            logger.debug('Requesting userinfo', {
                correlation_id: correlationId,
                meta: { user_id: token.sub }
            });
            const userinfoEndpoint = `${token.iss}/protocol/openid-connect/userinfo`;
            const axiosInstance = axios_1.default.create();
            axiosInstance.defaults.raxConfig = {
                instance: axiosInstance,
                // NOTE: turn off 'normal' retries - but can’t set this to 0, or else noResponseRetries doesn't work
                retry: 2,
                statusCodesToRetry: [],
                // e.g. ETIMEDOUT
                noResponseRetries: 2
            };
            rax.attach(axiosInstance);
            const headers = {
                authorization: `Bearer ${jwtToken}`
            };
            if (correlationId) {
                headers['klarna-correlation-id'] = correlationId;
            }
            const { data: userInfo } = yield axiosInstance.get(userinfoEndpoint, {
                proxy,
                timeout,
                headers,
                validateStatus: R.equals(200)
            });
            logger.debug('Received userinfo', {
                correlation_id: correlationId,
                meta: { user_id: token.sub }
            });
            if (token.sub !== userInfo.sub)
                throw new Error('Validation error - userinfo sub does not match supplied token sub');
            Object.assign(token, userInfo);
        }
        catch (error) {
            logger.error('Error getting user info', {
                correlation_id: correlationId,
                error: isLoggableError(error) ? error : undefined,
                payload: {
                    response: (isAxiosError(error) && error.response)
                        ? {
                            data: error.response.data,
                            status: error.response.status
                        }
                        : undefined
                }
            });
        }
    }
    token = resolveDefaults(token);
    return {
        // USER DATA
        getAzp: () => getAzp(token),
        getIssuer: () => getIssuer(token),
        getJti: () => getJti(token),
        getLoginSource: () => getLoginSource(token),
        getScopes: () => getScopes(token),
        getSessionState: () => getSessionState(token),
        getUserId: () => getUserId(token),
        getUsername: () => getUsername(token),
        getGivenName: () => getGivenName(token),
        getFamilyName: () => getFamilyName(token),
        getName: () => getName(token),
        getEmail: () => getEmail(token),
        getAllUserIds: () => getAllUserIds(token),
        getAudience: () => getAudience(token),
        getExpiration: () => getExpiration(token),
        getGroups: () => getGroups(token),
        getGroup: () => getGroup(token),
        getGroupId: () => getGroupId(token),
        getPids: () => getPids(token),
        getProxyUserId: () => getProxyUserId(token),
        getRealm: () => getRealm(token),
        getRegionFromIssuer: () => getRegionFromIssuer(token),
        getRegion: () => getRegion(token),
        hasScopes: (scopes) => hasScopes(token, scopes),
        isExpired: () => isExpired(token),
        isInKlarnaRealm: () => isInKlarnaRealm(token),
        isInMerchantsRealm: () => isInMerchantsRealm(token),
        isProxyUser: () => isProxyUser(token),
        isTransactingUser: () => isTransactingUser(token),
        // PERMISSIONS
        getAllPermissions: () => getAllPermissions(token),
        getAllPermissionsForMid: (mid) => getAllPermissionsForEntity(token, 'merchant', mid),
        getAllPermissionsForEid: (eid) => getAllPermissionsForEntity(token, 'estore', eid),
        getPermissions: (clientId) => getPermissions(token, clientId),
        hasPermission: (clientId, permission) => hasPermission(token, clientId, permission),
        hasUserPermission: (clientId, permission) => hasUserPermission(token, clientId, permission),
        getPermissionsForMid: (mid, clientId) => getPermissionsForEntity(token, 'merchant', mid, clientId),
        getPermissionsForEid: (eid, clientId) => getPermissionsForEntity(token, 'estore', eid, clientId),
        hasPermissionForMid: (mid, clientId, permission) => hasPermissionForEntity(token, 'merchant', mid, clientId, permission),
        hasPermissionForEid: (eid, clientId, permission) => hasPermissionForEntity(token, 'estore', eid, clientId, permission),
        hasPermissionForEntity: (entityType, entityId, clientId, permission) => hasPermissionForEntity(token, entityType, entityId, clientId, permission),
        hasPermissionForAnyEntity: (entityType, clientId, permission) => hasPermissionForAnyEntity(token, entityType, clientId, permission),
        hasFullPermission: (clientId) => hasFullPermission(token, clientId),
        hasFullPermissionForMid: (mid, clientId) => hasFullPermissionForEntity(token, 'merchant', mid, clientId),
        hasFullPermissionForEid: (eid, clientId) => hasFullPermissionForEntity(token, 'estore', eid, clientId),
        hasFullPermissionForEntity: (entityType, entityId, clientId) => hasFullPermissionForEntity(token, entityType, entityId, clientId),
        getMerchantPermissions: () => getPermissionsForEntityType(token, 'merchant'),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        getEStorePermissions: () => getPermissionsForEntityType(token, 'estore'),
        getKlarnaResourcePermissions: () => getPermissionsForEntityType(token, 'klarna_resource'),
        getPlatformPermissions: () => getPermissionsForEntityType(token, 'platform'),
        // ROLES
        getRoles: () => getRoles(token),
        hasRole: (role) => hasRole(token, role),
        getRolesForMid: (mid) => getRolesForEntity(token, 'merchant', mid),
        getRolesForKlarnaResource: (accountId) => getRolesForEntity(token, 'klarna_resource', accountId),
        getRolesForEid: (eid) => getRolesForEntity(token, 'estore', eid),
        getRolesForEntity: (entityType, entityId) => getRolesForEntity(token, entityType, entityId),
        getRolesForAllEntities: (entityType) => getRolesForAllEntities(token, entityType),
        hasRoleForMid: (mid, role) => hasRoleForEntity(token, 'merchant', mid, role),
        hasRoleForKlarnaResource: (accountId, role) => hasRoleForEntity(token, 'klarna_resource', accountId, role),
        hasRoleForEid: (eid, role) => hasRoleForEntity(token, 'estore', eid, role),
        hasRoleForEntity: (entityType, entityId, role) => hasRoleForEntity(token, entityType, entityId, role),
        hasRoleForAnyEntity: (entityType, role) => hasRoleForAnyEntity(token, entityType, role),
        // CLIENTS
        getClients: () => getClients(token),
        hasClient: (clientId) => hasClient(token, clientId),
        getClientsForMid: (mid) => getClientsForEntity(token, 'merchant', mid),
        getClientsForEid: (eid) => getClientsForEntity(token, 'estore', eid),
        getClientsForEntity: (entityType, entityId) => getClientsForEntity(token, entityType, entityId),
        getClientsForEntityType: (entityType) => getClientsForEntityType(token, entityType),
        getClientsForAllEntities: () => getClientsForAllEntities(token),
        hasClientForMid: (mid, clientId) => hasClientForEntity(token, 'merchant', mid, clientId),
        hasClientForEid: (eid, clientId) => hasClientForEntity(token, 'estore', eid, clientId),
        hasClientForEntity: (entityType, entityId, clientId) => hasClientForEntity(token, entityType, entityId, clientId),
        hasClientForEntityType: (entityType, clientId) => hasClientForEntityType(token, entityType, clientId),
        hasClientForAnyEntity: (clientId) => hasClientForAnyEntity(token, clientId),
        // ENTITIES
        getMids: () => getEntityIds(token, 'merchant'),
        getKlarnaResources: () => getEntityIds(token, 'klarna_resource'),
        getEids: () => getEntityIds(token, 'estore'),
        getPlatformKrns: () => getEntityIds(token, 'platform'),
        hasMid: (mid) => hasEntity(token, 'merchant', mid),
        hasKlarnaResource: (accountId) => hasEntity(token, 'klarna_resource', accountId),
        hasEid: (eid) => hasEntity(token, 'estore', eid),
        hasEntity: (entityType, entityId) => hasEntity(token, entityType, entityId),
        hasPendingMid: (mid) => hasPendingEntity(token, 'merchant', mid),
        getMidsForClient: (clientId) => getEntityIdsForClient(token, 'merchant', clientId),
        getEidsForClient: (clientId) => getEntityIdsForClient(token, 'estore', clientId),
        getMidsForRole: (role) => getEntityIdsForRole(token, 'merchant', role),
        getEidsForRole: (role) => getEntityIdsForRole(token, 'estore', role),
        getMidsForPermission: (clientId, permission) => getEntityIdsForPermission(token, 'merchant', clientId, permission),
        getEidsForPermission: (clientId, permission) => getEntityIdsForPermission(token, 'estore', clientId, permission),
        getEntityIdsForPermission: (entityType, clientId, permission) => getEntityIdsForPermission(token, entityType, clientId, permission),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        getEStores: () => getEstores(token),
        token,
        // DEPRECATED
        getDefaultPermissions: flagAsDeprecated(() => getDefaultPermissions(token), { logger }),
        hasDefaultPermissions: flagAsDeprecated(() => hasDefaultPermissions(token), { logger }),
        getClientIds: flagAsDeprecated(() => getClients(token), { replacementMethod: 'getClients', logger }),
        getClientIdsForMid: flagAsDeprecated((mid) => getClientsForEntity(token, 'merchant', mid), { replacementMethod: 'getClientsForMid', logger }),
        getClientIdsForEid: flagAsDeprecated((eid) => getClientsForEntity(token, 'estore', eid), { replacementMethod: 'getClientsForEid', logger }),
        getClientForEntity: flagAsDeprecated((entityType, entityId) => getClientsForEntity(token, entityType, entityId), { replacementMethod: 'getClientsForEntity', logger }),
        hasPermissionsForAnyEntity: flagAsDeprecated((entityType, clientId, permission) => hasPermissionForAnyEntity(token, entityType, clientId, permission), { replacementMethod: 'hasPermissionForAnyEntity', logger })
    };
});
exports.tokenHelperFactory = tokenHelperFactory;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getJwtToken = (req) => {
    var _a, _b;
    const authToken = (_b = (_a = req.context) === null || _a === void 0 ? void 0 : _a.authorizationToken) !== null && _b !== void 0 ? _b : req.get('authorization');
    return authToken ? authToken.replace('Bearer ', '') : null;
};
const createTokenHelperMiddleware = ({ factoryOpts = {}, publicErrors = false, tokenError = { message: 'No token in request', status: 401 } } = {}) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    return (req, res, next) => __awaiter(void 0, void 0, void 0, function* () {
        const jwtToken = getJwtToken(req);
        if (req.logger && !factoryOpts.logger) {
            factoryOpts.logger = req.logger;
        }
        if (!jwtToken) {
            return next((0, http_errors_1.default)(tokenError.status, tokenError.message, { public: publicErrors }));
        }
        try {
            const correlationId = req.header('klarna-correlation-id');
            req.tokenHelper = yield tokenHelperFactory(jwtToken, Object.assign(Object.assign({}, factoryOpts), { correlationId }));
            next();
        }
        catch (e) {
            return next((0, http_errors_1.default)(403, isError(e) ? e.message : 'Error', { public: publicErrors }));
        }
    });
};
exports.createTokenHelperMiddleware = createTokenHelperMiddleware;
const memoizeWithTokenHelper = (func) => utils.memoizeWith((tokenHelper) => tokenHelper.getJti(), func);
exports.memoizeWithTokenHelper = memoizeWithTokenHelper;
